// extracted by mini-css-extract-plugin
export var active = "sideMenu-module--active--xCLFn";
export var link = "sideMenu-module--link--oCN0s";
export var mark = "sideMenu-module--mark--57Zmv";
export var menu = "sideMenu-module--menu--4qmMh";
export var sideMenuWrapper = "sideMenu-module--sideMenuWrapper--6V3Rs";